import React from 'react';
import { Card } from 'primereact/card';

interface InstallmentsBankTransferSummary {
  totalPlans: number;
  totalAmount: number;
  paidAmount: number;
  pendingAmount: number;
  paidCount: number;
  totalInstallments: number;
}

interface HeaderCardsProps {
  summary: InstallmentsBankTransferSummary;
}

export const HeaderCards: React.FC<HeaderCardsProps> = ({ summary }) => {
  return (
    <div
      style={{
        display: 'flex',
        gap: '16px',
        marginBottom: '24px',
        flexWrap: 'wrap',
      }}
    >
      <Card
        style={{
          flex: '1 1 200px',
          minWidth: '200px',
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '16px', color: '#6b7280' }}>
            סה"כ הוראות קבע
          </div>
          <div
            style={{ fontSize: '28px', fontWeight: 'bold', color: '#1f2937' }}
          >
            {summary.totalPlans}
          </div>
        </div>
      </Card>

      <Card
        style={{
          flex: '1 1 200px',
          minWidth: '200px',
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '16px', color: '#6b7280' }}>סכום כולל</div>
          <div
            style={{ fontSize: '28px', fontWeight: 'bold', color: '#1f2937' }}
          >
            ₪{summary.totalAmount.toLocaleString()}
          </div>
        </div>
      </Card>

      <Card
        style={{
          flex: '1 1 200px',
          minWidth: '200px',
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '16px', color: '#6b7280' }}>שולם</div>
          <div
            style={{ fontSize: '28px', fontWeight: 'bold', color: '#22c55e' }}
          >
            ₪{summary.paidAmount.toLocaleString()}
          </div>
          <div style={{ fontSize: '14px', color: '#6b7280' }}>
            {summary.paidCount} מתוך {summary.totalInstallments} תשלומים
          </div>
        </div>
      </Card>

      <Card
        style={{
          flex: '1 1 200px',
          minWidth: '200px',
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '16px', color: '#6b7280' }}>ממתין לתשלום</div>
          <div
            style={{ fontSize: '28px', fontWeight: 'bold', color: '#f59e0b' }}
          >
            ₪{summary.pendingAmount.toLocaleString()}
          </div>
        </div>
      </Card>
    </div>
  );
};
